import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { content } from './shared/routes/content-routes';
import { ContentLayoutComponent } from './shared/layout/content-layout/content-layout.component';
import { LoginComponent } from './components/auth/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomeComponent } from './home/home.component';
import { AdminComponent } from './admin/admin.component';
import { AuthGuard } from './_helper/auth.guard';
import { Role } from './_models/role';
import { DashboardComponent } from './components/dashboard/dashboard.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'adminhkbkcms/auth/login',
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: '',
    component: ContentLayoutComponent,
    children: content
  },
  {
    path: 'adminhkbkcms/auth/login',
    component: LoginComponent,
  },
  {
    path: 'adminhkbkcms/dashboard',
    component: ContentLayoutComponent, // or your dashboard component
    canActivate: [AuthGuard],
    children: [
      { 
        path: 'default', 
        component: DashboardComponent // Replace with your actual dashboard component
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled'
  }),
  FormsModule,
  ReactiveFormsModule,
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
